import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  media: {
    height: 0,
    paddingTop: '100%', // 4:3
  },
}));
